import React, { useEffect, useState } from 'react';
import useTaskManagement from '../hooks/Tasks/useTaskManagement';
import { useAuthContext } from '../context/AuthContext';
import useUserPokemons from '../hooks/Pokemons/useUserPokemon';
import TaskItem from './TaskItem';
import styles from '../styles/TaskList.module.css';
import TaskForm from '../components/TaskForm';


const TaskList = ({ tasks = [], period, onClose }) => {
    const [showForm, setShowForm] = useState(false);
    const { user } = useAuthContext();
    const { userPokemons, isLoading } = useUserPokemons();
    const [selectedPokemon, setSelectedPokemon] = useState(null);

    const { removeTask } = useTaskManagement(user?.id, selectedPokemon);

    useEffect(() => {
        if (userPokemons?.length > 0 && !selectedPokemon) {
            setSelectedPokemon(userPokemons[0]);
        }
    }, [userPokemons, selectedPokemon]);

    const handleTaskDelete = (task) => {
        const pokemonId = task.userPokemon.split('/').pop();
        const taskPokemon = userPokemons?.find(
            p => p.user_pokemon_id.toString() === pokemonId
        );

        removeTask({
            taskId: task.id,
            difficulty: task.difficulty,
            taskPokemon: taskPokemon
        });
    };

    const handleFormAction = (action) => {
        if (action === 'cancel') {
            setShowForm(false);
        }
    };

    if (isLoading) return null;

    const filteredTasks = tasks.filter(task => {
        const pokemonId = task.userPokemon.split('/').pop();
        return selectedPokemon?.user_pokemon_id.toString() === pokemonId;
    });

    return (
        <div className={`${styles.taskListContainer}`}>
            <div className={`${styles.container}`}>
                <div className={`${styles.headerContainer}`}>
                    <p className={styles.title}>{selectedPokemon?.nom}</p>
                    <p className={styles.lenght}>{filteredTasks.length} tâches restantes</p>
                    <header className={styles.header}>
                        <div className={styles.pokemonSelector}>
                            <div className={styles.customSelect}>
                                {userPokemons.map(pokemon => (
                                    <div
                                        key={pokemon.user_pokemon_id}
                                        className={`${styles.customOption} ${selectedPokemon?.user_pokemon_id === pokemon.user_pokemon_id ? styles.selected : ''}`}
                                        onClick={() => setSelectedPokemon(pokemon)}
                                    >
                                        <img src={pokemon.icon} alt={pokemon.nom} className={styles.pokemonImage} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </header>
                </div>
                <div className={styles.taskListBg}></div>
                <div className={styles.taskListBody}>
                    <div className={styles.imgBg}>
                        <img src={selectedPokemon?.illustration} alt="" />
                    </div>
                    <ul className={`${styles.taskList} ${filteredTasks.length < 1 ? styles.empty : ''}`}>
                        {filteredTasks.length > 0 ? (
                            filteredTasks.map(task => {
                                const pokemonId = task.userPokemon.split('/').pop();
                                const taskPokemon = userPokemons?.find(
                                    p => p.user_pokemon_id.toString() === pokemonId
                                );
                
                                return (
                                    <TaskItem
                                        key={task.id}
                                        task={task}
                                        onDelete={() => handleTaskDelete(task)}
                                        pokemon={taskPokemon}
                                    />
                                );
                            })
                        ) : (
                            <div className={styles.noTask}></div>
                        )}
                    </ul>

                    <div className={`${styles.form} ${showForm ? styles.show : ''}`}>
                        <TaskForm showForm={showForm} period={period} selectedPokemon={selectedPokemon} onSuccess={() => setShowForm(false)} onAction={handleFormAction} />
                    </div>
                </div>
                <div className={styles.separator}></div>
                <div className={`${styles.footer} ${showForm ? styles.hide : styles.visible } ${filteredTasks.length < 1 ? styles.centered : ''}`}>
                                            
                                            <button
                                                style={{
                                                    backgroundColor: 'rgb(6, 202, 88)',
                                                    border: '4px solid rgb(9, 168, 59)'
                                                }}
                                                
                                                className={`${styles.modalButton} ${filteredTasks.length > 2 ? styles.bottomSide : ''}`}
                                                onClick={() => setShowForm(true)}
                                                aria-label="Ajouter une tâche"
                                            >
                                            <p>Nouvelle tâche</p>
                                            </button>
                </div>
            </div>
            <div className={`${styles.closeButton} button`}>

                <div className={`${styles.closeButtonIcon} icon`} onClick={onClose}>
                    <svg width="30" height="30" viewBox="0 0 669 774" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M345.71 0.439453H93.33C78.07 0.439453 65.7 12.8095 65.7 28.0695C65.7 43.3295 78.07 55.6994 93.33 55.6994H345.71C491.47 55.6994 610.33 173.039 612.79 318.229C615.32 467.649 489.08 589.949 339.64 589.949H94.31L95.48 588.829L170.66 513.649C181.45 502.859 181.45 485.359 170.66 474.569C159.87 463.779 142.37 463.779 131.58 474.569L9.04001 597.109C-1.74999 607.899 -1.74999 625.399 9.04001 636.189L138.31 765.459C149.1 776.249 166.6 776.249 177.39 765.459C188.18 754.669 188.18 737.169 177.39 726.379L96.23 645.219H338.85C514.28 645.219 662.75 507.929 667.95 332.579C673.35 150.379 526.71 0.439453 345.71 0.439453Z" fill="#34221e65"/>
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default TaskList;
